export const youTubeLinkRegExp = /^https:\/\/www\.youtube\.com\/watch\?v=[a-zA-Z0-9-_]{1,30}$/gm;
